module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "journey-flow-viewer",
    style: ({
      '--sidebar-w': _vm.sidebarOpen ? '240px' : '40px',
      '--explorer-w': (_vm.currentJourneyJson ? _vm.explorerWidth : 0) + 'px'
    })
  }, [_c('builder-top-bar', {
    attrs: {
      "has-journey": !!_vm.currentJourneyJson,
      "validating": _vm.validating,
      "validation-result": _vm.validationResult,
      "promoting": _vm.promoting,
      "promote-result": _vm.promoteResult
    },
    on: {
      "validate": _vm.onValidateJourney,
      "promote": _vm.onPromoteToProduction
    }
  }), _vm._v(" "), _c('journey-sidebar', {
    ref: "journeySidebar",
    attrs: {
      "journey-keys": _vm.journeyKeys,
      "current-journey-key": _vm.currentJourneyKey,
      "versions": _vm.currentJourneyVersions,
      "active-version-number": _vm.currentVersionNumber
    },
    on: {
      "journey-change": function($event) {
        return _vm.onJourneyChange($event)
      },
      "toggle-open": function($event) {
        return _vm.onSidebarToggle($event)
      },
      "create-new": function($event) {
        return _vm.onCreateNew()
      },
      "select-version": function($event) {
        return _vm.onSelectVersion($event)
      }
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "canvas-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('div', {
    staticClass: "canvas",
    attrs: {
      "id": "canvas"
    }
  }, [_c('svg', {
    staticClass: "lines",
    attrs: {
      "id": "svg"
    }
  })])]), _vm._v(" "), (_vm.currentJourneyJson) ? _c('div', {
    staticClass: "view-controls"
  }, [(_vm.currentVersionNumber) ? _c('span', {
    staticClass: "vc-version-badge",
    attrs: {
      "title": "Version currently shown"
    }
  }, [_vm._v("v" + _vm._s(_vm.currentVersionNumber))]) : _vm._e(), _vm._v(" "), _c('view-mode-switcher', {
    attrs: {
      "value": _vm.viewMode
    },
    on: {
      "change": function($event) {
        return _vm.onViewModeChange($event)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "vc-comments-btn",
    attrs: {
      "title": "View all comments"
    },
    on: {
      "click": function($event) {
        _vm.allCommentsOpen = true
      }
    }
  }, [_vm._v("\n      💬 All comments\n      "), (_vm.totalCommentCount) ? _c('span', {
    staticClass: "vc-comments-count"
  }, [_vm._v(_vm._s(_vm.totalCommentCount))]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.allCommentsOpen) ? _c('all-comments-modal', {
    attrs: {
      "journey-key": _vm.currentJourneyKey
    },
    on: {
      "close": function($event) {
        _vm.allCommentsOpen = false
      },
      "select-stage": function($event) {
        return _vm.onSelectStageFromAllComments($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentJourneyJson) ? _c('div', {
    staticClass: "editor-actions"
  }, [_c('button', {
    staticClass: "ea-btn ea-wa",
    attrs: {
      "title": "Test in WhatsApp"
    },
    on: {
      "click": function($event) {
        _vm.whatsappPreviewOpen = true
      }
    }
  }, [_vm._v("WhatsApp Preview")]), _vm._v(" "), _c('button', {
    staticClass: "ea-icon-btn",
    attrs: {
      "title": "Download JSON"
    },
    on: {
      "click": function($event) {
        return _vm.onDownload()
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "15",
      "height": "15",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
    }
  }), _c('polyline', {
    attrs: {
      "points": "7 10 12 15 17 10"
    }
  }), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "15",
      "x2": "12",
      "y2": "3"
    }
  })])]), _vm._v(" "), (_vm.viewMode === 'client' && _vm.presentationData) ? _c('button', {
    staticClass: "ea-btn ea-wa",
    attrs: {
      "title": "Download standalone Client View HTML"
    },
    on: {
      "click": function($event) {
        return _vm.onDownloadClientViewHtml()
      }
    }
  }, [_vm._v("Download HTML")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "ea-btn ea-save",
    attrs: {
      "title": "Save New Version"
    },
    on: {
      "click": function($event) {
        return _vm.onOpenSaveVersion()
      }
    }
  }, [_vm._v("Save New Version")])]) : _vm._e(), _vm._v(" "), (_vm.saveVersionModalOpen) ? _c('save-version-modal', {
    attrs: {
      "journey-name": _vm.currentJourneyKey,
      "next-version-number": _vm.nextVersionNumber,
      "previous-journey-json": _vm.previousVersionSnapshot,
      "current-journey-json": _vm.currentJourneyJson
    },
    on: {
      "cancel": function($event) {
        return _vm.onCancelSaveVersion()
      },
      "save": function($event) {
        return _vm.onConfirmSaveVersion($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "canvas-controls"
  }, [_c('button', {
    staticClass: "tb-btn",
    attrs: {
      "title": "Reset layout"
    },
    on: {
      "click": function($event) {
        return _vm.onResetLayout()
      }
    }
  }, [_vm._v("↺")]), _vm._v(" "), _c('button', {
    staticClass: "tb-btn",
    attrs: {
      "title": "Fit to screen"
    },
    on: {
      "click": function($event) {
        return _vm.onFitScreen()
      }
    }
  }, [_vm._v("⛶")]), _vm._v(" "), _c('div', {
    staticClass: "tb-sep"
  }), _vm._v(" "), (_vm.viewMode !== 'client' && _vm.viewMode !== 'flow') ? [_c('button', {
    staticClass: "tb-btn",
    attrs: {
      "title": "Collapse all"
    },
    on: {
      "click": function($event) {
        return _vm.onCollapseAll()
      }
    }
  }, [_vm._v("⊟")]), _vm._v(" "), _c('button', {
    staticClass: "tb-btn",
    attrs: {
      "title": "Expand all"
    },
    on: {
      "click": function($event) {
        return _vm.onExpandAll()
      }
    }
  }, [_vm._v("⊞")]), _vm._v(" "), _c('div', {
    staticClass: "tb-sep"
  })] : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "tb-btn",
    attrs: {
      "title": "Zoom out"
    },
    on: {
      "click": function($event) {
        return _vm.onZoomOut()
      }
    }
  }, [_vm._v("−")]), _vm._v(" "), _c('span', {
    staticClass: "zoom-info"
  }, [_vm._v(_vm._s(_vm.zoomPercent) + "%")]), _vm._v(" "), _c('button', {
    staticClass: "tb-btn",
    attrs: {
      "title": "Zoom in"
    },
    on: {
      "click": function($event) {
        return _vm.onZoomIn()
      }
    }
  }, [_vm._v("+")]), _vm._v(" "), _c('div', {
    staticClass: "tb-sep"
  }), _vm._v(" "), _c('button', {
    staticClass: "tb-btn",
    class: {
      active: _vm.scrollZoomEnabled
    },
    attrs: {
      "title": "Toggle scroll-to-zoom (off = scroll to pan)"
    },
    on: {
      "click": function($event) {
        return _vm.onToggleScrollZoom()
      }
    }
  }, [_vm._v("🔍")])], 2), _vm._v(" "), (_vm.hasSelection) ? _c('div', {
    staticClass: "selection-controls"
  }, [_c('button', {
    staticClass: "mode-btn",
    class: {
      active: _vm.selMode === 'dim'
    },
    attrs: {
      "title": "Dim others on select"
    },
    on: {
      "click": function($event) {
        return _vm.onSelModeChange('dim')
      }
    }
  }, [_vm._v("Dim")]), _vm._v(" "), _c('button', {
    staticClass: "mode-btn",
    class: {
      active: _vm.selMode === 'focus'
    },
    attrs: {
      "title": "Hide others on select"
    },
    on: {
      "click": function($event) {
        return _vm.onSelModeChange('focus')
      }
    }
  }, [_vm._v("Focus")])]) : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.viewMode !== 'client' && _vm.currentJourneyJson) ? _c('stage-explorer', {
    ref: "stageExplorer",
    attrs: {
      "stages": _vm.stageExplorerList,
      "selected-stage": _vm.selectedStageDetail,
      "lang-options": _vm.langOptions,
      "current-lang": _vm.currentLang,
      "journey-key": _vm.currentJourneyKey
    },
    on: {
      "select-stage": function($event) {
        return _vm.onSelectStageFromExplorer($event)
      },
      "deselect": function($event) {
        return _vm.onDeselectStage()
      },
      "update-message": function($event) {
        return _vm.onUpdateStageMessage($event)
      },
      "update-topics": function($event) {
        return _vm.onUpdateStageTopics($event)
      },
      "width-change": function($event) {
        return _vm.onExplorerWidthChange($event)
      }
    }
  }) : (_vm.currentJourneyJson) ? _c('phase-explorer', {
    ref: "phaseExplorer",
    attrs: {
      "presentation": _vm.presentationData,
      "selected-phase": _vm.selectedPhaseDetail,
      "loading": _vm.presentationLoading
    },
    on: {
      "select-phase": function($event) {
        return _vm.onSelectPhaseFromExplorer($event)
      },
      "deselect": function($event) {
        return _vm.onDeselectPhase()
      },
      "width-change": function($event) {
        return _vm.onExplorerWidthChange($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('journey-chat', {
    ref: "journeyChat",
    attrs: {
      "current-journey-json": _vm.currentJourneyJson
    },
    on: {
      "journey-generated": function($event) {
        return _vm.onJourneyGenerated($event)
      }
    }
  }), _vm._v(" "), (_vm.cardMenu.visible) ? _c('div', {
    staticClass: "card-ctx-menu",
    style: ({
      left: _vm.cardMenu.x + 'px',
      top: _vm.cardMenu.y + 'px'
    })
  }, [_c('button', {
    staticClass: "card-ctx-item",
    on: {
      "click": function($event) {
        return _vm.onAiEditStage()
      }
    }
  }, [_vm._v("✨ Change / Update using AI")]), _vm._v(" "), _c('button', {
    staticClass: "card-ctx-item",
    on: {
      "click": function($event) {
        return _vm.onAddComment()
      }
    }
  }, [_vm._v("💬 Add Comment")])]) : _vm._e(), _vm._v(" "), (_vm.whatsappPreviewOpen) ? _c('whatsapp-preview', {
    attrs: {
      "journey": _vm.currentJourneyJson,
      "current-lang": _vm.currentLang,
      "lang-options": _vm.langOptions
    },
    on: {
      "close": function($event) {
        _vm.whatsappPreviewOpen = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "empty-hint",
    attrs: {
      "id": "empty-hint"
    }
  }, [_c('div', [_c('div', {
    staticClass: "big"
  }, [_vm._v("🧭")]), _vm._v("\n      Select a journey from the sidebar to visualize the flow\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "conn-tooltip",
    attrs: {
      "id": "conn-tooltip"
    }
  }, [_c('span', {
    staticClass: "ct-icon"
  }, [_vm._v("🖱️")]), _c('span', {
    staticClass: "ct-text",
    attrs: {
      "id": "ct-text"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-6857f5b6","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user-journey/CreateNewJourney.vue
// module id = 5QpB
// module chunks = 1